import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import routePaths from 'routePaths';
import AwdMapView from 'modules/AwdMapView';
import Telematics from 'modules/Telematics';
import SugarcaneMapView from 'modules/SugarcaneMapView';

import CommonView from 'modules/CommonView';
import Loader from './sharedComponents/Loader';

const MapView = React.lazy(() => import('./modules/MapView'));
const Router = () => {
	const loading = useSelector((s) => s.global.loader) > 0;
	const authToken = useSelector((s) => s.global.authToken);

	return (
		<>
			<Suspense fallback={<Loader loading />}>
				<Switch>
					{/* Map */}
					<Route path={routePaths.mapView} exact>
						<MapView />
					</Route>

					{/* Telematics */}
					<Route path={routePaths.telematics} exact>
						<Telematics />
					</Route>

					{/* Draw */}
					<Route path={routePaths.drawView} exact>
						<MapView />
					</Route>

					{/* Roundnut */}
					<Route path={routePaths.programs} exact>
						<CommonView />
					</Route>

					{/* Sugarcane */}
					<Route path={routePaths.sugarcane} exact>
						<SugarcaneMapView />
					</Route>

					{/* Awd */}
					<Route path={routePaths.awd} exact>
						<AwdMapView />
					</Route>

					{/* TODO: Add 404 error page */}
					{/* FALLBACK */}
					<Route path="*">
						<Redirect push to={routePaths.mapView} />
					</Route>
				</Switch>
			</Suspense>
			<Loader loading={loading || authToken.length === 0} />
		</>
	);
};

export default Router;
